module.exports = __webpack_public_path__ + "media/images/emblems/Vechigen-coat_of_arms-3dcb49950a5f941bf73db70d9ea8d50e.svg";